// extracted by mini-css-extract-plugin
export default {"dropdown_container":"TipMessage_dropdown_container__K0doq","height_60":"TipMessage_height_60__m39vH"};